<div class="contenedor-blogs">
  @if (blogs.length == 0) {
    <h1>No existen blogs.</h1>
  } @else {
    @for (item of blogs; track item; let i = $index) {
      <a class="blog-item" [routerLink]="[item?.slug]">
        <div class="titulo-blog">
          <div class="imagenPost">
            <app-skeleton-image [size]="150" [src]="item?.foto" [aspectRatio]="'1'" [customClass]="'imagen-autor'" [lazy]="i < 5 ? false : true"></app-skeleton-image>
          </div>
          <h1>{{ item?.nombreSubSeccion }}</h1>
        </div>
      </a>
    }
  }
</div>
